import { render, staticRenderFns } from "./titleDetails.vue?vue&type=template&id=ed13392a&scoped=true&lang=pug&"
import script from "./titleDetails.vue?vue&type=script&lang=js&"
export * from "./titleDetails.vue?vue&type=script&lang=js&"
import style0 from "./titleDetails.vue?vue&type=style&index=0&id=ed13392a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed13392a",
  null
  
)

export default component.exports